export const INVALID_URL = 'Please make sure you have entered a valid URL.'
